import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: '' }

export const appStatsAction = createAsyncThunk(
    'appStats',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/app/stats?startDate=${data?.startDate || ""}&endDate=${data?.endDate || ""}&page=${data?.page || 1}&limit=${data?.limit || 25}`, )
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const appStatsSlice = createSlice({
    name:'appStats',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(appStatsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(appStatsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(appStatsAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const appStatsReducer = appStatsSlice.reducer